// axios
import axios from 'axios'

//const baseURL = 'http://167.172.238.237:8001'
//~ const baseURL = 'http://ec2-18-220-187-247.us-east-2.compute.amazonaws.com/'

const baseURL = 'https://api.2nomi.com/'

export default axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': '*/*'
  }
  // You can add your headers here
})
